import { render, staticRenderFns } from "./tabs-skeleton.vue?vue&type=template&id=91c76edc&scoped=true&"
import script from "./tabs-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./tabs-skeleton.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c76edc",
  null
  
)

export default component.exports